import { useIntl } from "react-intl";
import { FC } from "react";
import ReportStatusSection from "@src/frontpage/ReportStatusSection";
import Notifications from "@src/frontpage/Notifications";
import styled from "styled-components";
import RPLogoFi from "@src/images/RPLogoFi.jpg";
import RPLogoEn from "@src/images/RPLogoEn.jpg";
import RPLogoSv from "@src/images/RPLogoSv.jpg";
import { useAppSelector } from "@src/reduxStore";
import { Language } from "@src/i18n";
import { RPFormattedMessage } from "@src/i18n";
import { OrgCountry, useOrgInfo } from "@src/common/reliablePartnerApi";

const BubbleNE = styled.div`
  border: 3px solid #333;
  border-radius: 30px 0 30px 30px;
  padding: 30px;
`;

const BubbleSW = styled.div`
  border: 3px solid #333;
  border-radius: 30px 30px 30px 0;
  padding: 30px;
`;

const LocalizedRpLogo: FC<{ language: Language }> = ({ language }) => {
  const intl = useIntl();

  const altText = intl.formatMessage({
    id: "rpLogoAltText",
    defaultMessage: "Luotettava Kumppani -logo",
  });

  switch (language) {
    case "fi":
      return <img className="w-75" src={RPLogoFi} alt={altText} />;
    case "en":
      return <img className="w-75" src={RPLogoEn} alt={altText} />;
    case "sv":
      return <img className="w-75" src={RPLogoSv} alt={altText} />;
    case "et":
      return <img className="w-75" src={RPLogoEn} alt={altText} />; // TODO: Add missing estonian localized logo?
  }
};

const Frontpage = () => {
  const locale = useAppSelector(state => state.common.language);
  const orgInfo = useOrgInfo();
  const orgBusinessId = orgInfo.data?.registrationNumber;
  const orgCountry = orgInfo.data?.country || OrgCountry.FI;

  const countryCodeMap = {
    [OrgCountry.EE]: "EST",
    [OrgCountry.FI]: "FIN",
    [OrgCountry.LT]: "LTU",
    [OrgCountry.LV]: "LVA",
    [OrgCountry.PL]: "POL",
    [OrgCountry.SE]: "SWE",
  };

  return (
    <div className="container-fluid mt-6">
      <div className="row align-items-center d-flex pt-5 pb-5">
        <div className="col-12 col-sm-12 col-md-5 mb-6 mb-md-0">
          <RPFormattedMessage
            id="frontPageWelcome"
            defaultMessage="Tervetuloa Luotettava Kumppani tilaajavastuutiedot -palveluun!"
          />
          <br />
          <br />
          <RPFormattedMessage
            id="frontPageBasics"
            defaultMessage={
              "Palvelun ydin on tilaajavastuuraportti. Raportti osoittaa, että yrityksen toiminta on läpinäkyvää ja tilaajavastuulain vaatimat velvoitteet on täytetty."
            }
          />
        </div>
        <div className="col-12 col-sm-12 col-md-6 ml-auto align-self-center">
          <BubbleNE>
            <RPFormattedMessage
              id="frontPageReportService"
              defaultMessage={
                "Yrityksesi tilaajavastuuraportti on nähtävillä <linkToReportService>Raportti</linkToReportService>-palvelun kautta."
              }
              extraRTEProps={{
                linkToReportService: {
                  countryCode: countryCodeMap[orgCountry],
                  orgBusinessId,
                },
              }}
            />
            <br />
            <br />
            <RPFormattedMessage
              id="frontPageZeckit"
              defaultMessage={
                "Tiedot ovat nähtävillä myös kuluttajille suunnatussa <linkToZeckit>Zeckit</linkToZeckit>-palvelussa."
              }
            />
          </BubbleNE>
        </div>
      </div>
      <ReportStatusSection />
      <Notifications />
      <div className="row pt-5 pb-5">
        <div className="col-md-8 mb-6 mb-md-0">
          <BubbleSW>
            <RPFormattedMessage
              id="frontPageServiceInstructions"
              defaultMessage={
                "Tarkemmat ohjeet löydät <linkToRPInstructionCenter>Luotettava Kumppani -ohjekeskuksestamme</linkToRPInstructionCenter>."
              }
            />
            <br />
            <br />
            <RPFormattedMessage
              id="frontPageCustomerServiceInstructions"
              defaultMessage={
                "Eikö tietoa löytynyt muualta? Ei hätää, <linkToCustomerService>asiakaspalvelumme</linkToCustomerService> auttaa."
              }
            />
          </BubbleSW>
        </div>
        <div className="col-md-4 d-flex flex-column text-md-right">
          <RPFormattedMessage
            id="frontPageUseLogo"
            defaultMessage="Haluatko logon käyttöösi? <linkToLogoInstructions>Lue tästä ohjeet!</linkToLogoInstructions>"
          />
          <div className="pt-5">
            <LocalizedRpLogo language={locale} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frontpage;
